import { EBenefitState, ELoyaltyType, ILoyaltyItem } from '../model';

export interface IFreeDeliveryBenefit {
  freeDeliveryLimit?: number | null;
  activationThreshold: number;
  date?: Date | null;
  state: EBenefitState;
}

/**
 * Method returns free delivery benefit if it is present in customer benefits. If benefit is not present method returns null.
 * @param benefits - Customer benefits
 */
export const getDeliveryBenefit = (benefits: ILoyaltyItem[]): IFreeDeliveryBenefit | null => {
  const freeDeliveryBenefit = benefits.find((benefit) => benefit.loyaltyType === ELoyaltyType.FREE_DELIVERY);

  if (!freeDeliveryBenefit) {
    return null;
  }

  return {
    freeDeliveryLimit: freeDeliveryBenefit.minimalOrderPriceThresholdWithVat,
    activationThreshold: freeDeliveryBenefit.orderPriceActivationThresholdWithVat,
    date: freeDeliveryBenefit.expirationDate,
    state: freeDeliveryBenefit.state,
  };
};
